export default "/_next/static/chunks/fonts/WhitneySSm-BlackItalic-Pro_Web-8da7744d7f7c6b64daebe05538429537.woff";